
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutReturnGrid extends Serenity.EntityGrid<ApprovalOutReturnRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutReturn'; }
        protected getDialogType() { return ApprovalOutReturnDialog; }
        protected getIdProperty() { return ApprovalOutReturnRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutReturnRow.localTextPrefix; }
        protected getService() { return ApprovalOutReturnService.baseUrl; } 
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) { 
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {

            let now = new Date(); 
            var voucherNo = FormatHelper.GetVoucherNo(34);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[34].AutoPosting;

            this.editItem(<ApprovalOutReturnRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId, 
                VoucherTypeId: 34,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions(); 
        }
        protected getButtons(): Serenity.ToolButton[] {
            var btn = super.getButtons();

            btn.push({
                title: 'Import Approval In Returns',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    if (!this.onViewSubmit()) {
                        return;
                    }

                    let transids;
                    ApprovalOutReturnService.PostedTransIdList({}, response => { transids = response.Entities }, { async: false });
                    var _transids = transids.map(x => x.RefTransId);
                    var dialog = new Common.VoucherPostingDialog();
                    dialog.transids = _transids;
                    dialog.vouchertypeid = 33;

                    dialog.element.height(500);
                    dialog.element.width(500);
                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();

                        if (dialog.checksuccess) {
                            var partyid = parseInt(dialog.form.PartyId.value);
                            if (dialog.vouchernos.length > 0)

                                ApprovalOutReturnService.APIImportApprovalInReturns({ Entities: dialog.vouchernos, PartyId: partyid }, response => { this.refresh() }, { async: false });
                        }
                    });

                }
            });
            return btn;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}